import React, { useEffect, useState } from "react";
import CoreTypographyBody1 from "../../core/dataDisplay/CoreTypographyBody1";
import { Box, Grid, Icon, Tooltip } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  api_request,
  downloadFileCommon,
} from "../../store/actions/commonAction";
import {
  DOC_PART_DOWNLOAD_ERROR,
  DOC_PART_DOWNLOAD_LOADING,
  DOC_PART_DOWNLOAD_SUCCESS,
  UPDATE_DOC_ERROR,
  UPDATE_DOC_LOADING,
  UPDATE_DOC_SUCCESS,
} from "../../store/types/billTypes";
import CoreDataTable from "../../core/dataDisplay/datatable/CoreDataTable";
import Swal from "sweetalert2";
import { theme } from "../../config/theme";
import { API_METHOD_POST, API_METHOD_PUT } from "../../config/constants";
import CoreIconButton from "../../core/inputs/CoreIconButton";
import CoreModal from "../../core/layouts/CoreModal";
import CoreInput from "../../core/inputs/CoreInput";
import { Formik } from "formik";
import {
  addDataSchema,
  addDataSchemaMulti,
  fieldEditSchema,
  fieldEditSchemaMulti,
} from "../../formSchemas/docSchemas";
import CoreButtonContainer from "../../core/layouts/CoreButtonContainer";
import CoreContainedButton from "../../core/inputs/CoreContainedButton";

export default function EditablePartsTable({
  data,
  docHisId,
  multiLine,
  typeMap,
  valMap,
}) {
  const dispatch = useDispatch();
  const [heads, setHeads] = useState([]);
  const [newRows, setNewRows] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [newData, setNewData] = useState({});
  const [currentRow, setCurrentRow] = useState(null);
  const [currentOrder, setCurrentOrder] = useState(null);
  const [newEditInfo, setNewEditInfo] = useState({});
  const [newEditValue, setNewEditValue] = useState({});

  const userId = useSelector((state) => state.auth?.uid);
  const docId = useSelector((state) => state.bill?.docId);
  const newDocHisId = useSelector((state) => state.bill.newDocHisId);

  useEffect(() => {
    if (modalOpen) {
      setModalOpen(false);
    }
    if (data?.length > 0) {
      let tempHeads = [];
      for (let i = 0; i < data?.length; i++) {
        let item = data[i];
        if (item.Children.length > 0) {
          if (item.Children[0]?.Children?.length > 0) {
            tempHeads.push(
              item.Children[0]?.Children?.map((head) => {
                return {
                  name: head.name,
                  label: head.label,
                  id: (row) => {
                    return (
                      row?.Children?.find((elem) => elem.name === head.name)
                        ?.id || ""
                    );
                  },
                  view: (row) => {
                    return (
                      row?.Children?.find((elem) => elem.name === head.name)
                        ?.value || ""
                    );
                  },
                };
              }),
            );
          } else {
            tempHeads.push([
              {
                name: "text",
                label: "Text",
                id: (row) => {
                  return row.id;
                },
                view: (row) => {
                  return row.value;
                },
              },
            ]);
          }
        } else {
          tempHeads.push([]);
        }
      }
      setHeads(tempHeads);
    }
  }, [data]);

  const onSave = (id, val) => {
    if (!newDocHisId) {
      dispatch(
        api_request(
          "POST",
          "/error/notification",
          {
            userId,
            docId,
          },
          {},
          "ERROR_NOTIFICATION_LOADING",
          "ERROR_NOTIFICATION_SUCCESS",
          "ERROR_NOTIFICATION_ERROR",
          true,
          false,
          true,
        ),
      );
    }
    dispatch(
      api_request(
        "POST",
        "/doc/part/" + id + "/update",
        {
          value: val,
          docHistoryId: newDocHisId || docHisId,
          newHistoryFlag: newDocHisId ? false : true,
        },
        {},
        UPDATE_DOC_LOADING,
        UPDATE_DOC_SUCCESS,
        UPDATE_DOC_ERROR,
        true,
        false,
        true,
      ),
    );
  };

  const deleteAll = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to delete all the rows",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      confirmButtonColor: theme.palette.primary.main,
      icon: "warning",
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(
          api_request(
            API_METHOD_PUT,
            "/doc/parts/delete",
            { docHistoryId: newDocHisId || docHisId },
            {},
            UPDATE_DOC_LOADING,
            UPDATE_DOC_SUCCESS,
            UPDATE_DOC_ERROR,
            true,
            false,
            true,
          ),
        );
      }
    });
  };

  const onDelete = (doc) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to delete the rows",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      confirmButtonColor: theme.palette.primary.main,
      icon: "warning",
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(
          api_request(
            API_METHOD_PUT,
            "/doc/parts/delete",
            { partId: Array.isArray(doc) ? doc : doc?.id },
            {},
            UPDATE_DOC_LOADING,
            UPDATE_DOC_SUCCESS,
            UPDATE_DOC_ERROR,
            true,
            false,
            true,
          ),
        );
      }
    });
  };

  const onDownloadTable = (label, data) => {
    console.log("downloading table data", data);
    dispatch(
      downloadFileCommon({
        fileName: `${label}.xlsx`,
        body: data,
        path: "/doc/part/download",
      }),
    );
  };

  const addNew = (row, order) => {
    setCurrentRow(row);
    setCurrentOrder(order);
    let rows =
      row?.Children?.length > 0
        ? row?.Children
        : [{ name: row.name, label: row.label }];
    console.log("rows", rows, row);
    let tempNewData = {};
    let tempNewRows = rows?.map((row) => {
      tempNewData[row.name] = "";
      return {
        name: row.name,
        value: "",
        label: row.label,
        order: row.order,
      };
    });
    console.log("tempNewRows", tempNewRows, tempNewData);
    setNewRows(tempNewRows);
    setModalOpen(true);
    setNewData(tempNewData);
  };

  const onAddRow = (values) => {
    console.log("values", values);
    let newValues = Object.keys(values).map((field) => {
      return {
        name: field,
        label: newRows?.find((row) => row.name === field)?.label || field,
        value: values[field],
        order: currentOrder || 0,
      };
    });

    if (newValues?.length === 1 && newValues[0].name === "text") {
      newValues = newValues[0].value;
    }
    if (!newDocHisId) {
      dispatch(
        api_request(
          "POST",
          "/error/notification",
          {
            userId,
            docId,
          },
          {},
          "ERROR_NOTIFICATION_LOADING",
          "ERROR_NOTIFICATION_SUCCESS",
          "ERROR_NOTIFICATION_ERROR",
          true,
          false,
          true,
        ),
      );
    }
    dispatch(
      api_request(
        "POST",
        "/doc/part/" + currentRow.parentId + "/add",
        {
          rowName: currentRow.name,
          data: newValues,
          order: currentOrder || 0,
          docHistoryId: newDocHisId || docHisId,
          newHistoryFlag: newDocHisId ? false : true,
        },
        {},
        UPDATE_DOC_LOADING,
        UPDATE_DOC_SUCCESS,
        UPDATE_DOC_ERROR,
        true,
        false,
        true,
      ),
    );
  };

  const onBulkEdit = (editData, editValue) => {
    let tempEditValue = { ...newEditValue, ...editValue };
    let tempEditData = { ...newEditInfo, ...editData };
    setNewEditValue(tempEditValue);
    setNewEditInfo(tempEditData);
  };

  const onBulkSave = () => {
    if (!newDocHisId) {
      dispatch(
        api_request(
          "POST",
          "/error/notification",
          {
            userId,
            docId,
          },
          {},
          "ERROR_NOTIFICATION_LOADING",
          "ERROR_NOTIFICATION_SUCCESS",
          "ERROR_NOTIFICATION_ERROR",
          true,
          false,
          true,
        ),
      );
    }

    dispatch(
      api_request(
        "POST",
        "/doc/part/bulk",
        {
          dataArr: Object.entries(newEditValue)
            .map(([key, value]) => ({ id: key, value }))
            .filter((item) => newEditInfo[String(item.id)]),
          docHistoryId: newDocHisId || docHisId,
          newHistoryFlag: newDocHisId ? false : true,
        },
        {},
        UPDATE_DOC_LOADING,
        UPDATE_DOC_SUCCESS,
        UPDATE_DOC_ERROR,
        true,
        false,
        true,
      ),
    );
  };

  console.log("particular", newEditInfo, newEditValue);

  return (
    <Grid item xs={12}>
      <div
        style={{
          marginTop: "-58px",
          position: "fixed",
          marginLeft: "20%",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            padding: "8px",
          }}
        >
          <CoreIconButton onClick={onBulkSave}>
            <Tooltip title="Save All" placement="top">
              <Icon>save</Icon>
            </Tooltip>
          </CoreIconButton>
        </div>
      </div>
      <CoreModal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        title="Add New Row"
      >
        <Formik
          initialValues={newData}
          validationSchema={
            multiLine
              ? addDataSchemaMulti(Object.keys(newData))
              : addDataSchema(Object.keys(newData))
          }
          onSubmit={onAddRow}
          enableReinitialize
        >
          {(formikProps) => (
            <>
              {newRows?.map((row, i) => (
                <Box key={row.name + "-" + i} sx={{ marginBottom: 2 }}>
                  <CoreInput
                    formikProps={formikProps}
                    label={row.label}
                    id={row.name}
                    value={formikProps.values[row.name] || ""}
                    onChange={formikProps.handleChange}
                  />
                </Box>
              ))}
              <CoreButtonContainer>
                <CoreContainedButton
                  type="button"
                  color="error"
                  onClick={() => setModalOpen(false)}
                >
                  Cancel
                </CoreContainedButton>
                <CoreContainedButton
                  type="submit"
                  sx={{ ml: 2 }}
                  onClick={formikProps.handleSubmit}
                >
                  Submit
                </CoreContainedButton>
              </CoreButtonContainer>
            </>
          )}
        </Formik>
      </CoreModal>
      {data?.length === 0 && <p>No Tabular Data</p>}

      {data?.map((type, i) => (
        <div
          style={{ display: "block", padding: 8 }}
          className="row"
          key={type.label + "-" + i}
        >
          <Box
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              marginBottom: 0,
            }}
          >
            <CoreTypographyBody1>
              <strong>{type.label}</strong>
            </CoreTypographyBody1>
            <Tooltip title="Download Table">
              <CoreIconButton
                onClick={() => onDownloadTable(type.label, type?.Children)}
              >
                <Icon>download</Icon>
              </CoreIconButton>
            </Tooltip>
          </Box>
          <CoreDataTable
            actions={[
              {
                title: "Add New",
                icon: "add",
                onClick: () => {
                  addNew(type?.Children?.[0], type?.Children?.length);
                },
              },
              { title: "Delete all", icon: "delete_sweep", onClick: deleteAll },
            ]}
            rowActions={[{ icon: "delete", onClick: onDelete, bulk: true }]}
            columns={heads && heads[i] ? heads[i] : []}
            dataRows={type?.Children || []}
            elevation={false}
            onSave={onSave}
            editable={true}
            onChangeHook={onBulkEdit}
            inputTypeMap={typeMap?.[type.name] || {}}
            inputValMap={valMap?.[type.name] || {}}
          />
        </div>
      ))}
    </Grid>
  );
}
